import React from "react";
import { useSelector } from "react-redux";
import Grid from "@material-ui/core/Grid";

import { formatNumber } from "lib";

import {
  selectLottedHeadCount,
  selectProgenyHeadCount,
  selectSoldLiveWeightHeadCount,
  selectSoldLiveWeightProgenyCount,
  selectSoldOpenAuctionHeadCount,
  selectSoldOpenAuctionProgenyCount,
} from "selectors/counts";
import { PricingTypeId, pricingTypeToString } from "constants/pricingTypes";
import { getProgenyDisplayCount } from "lib/saleLot";
import { SaleProgressHashTotal } from "./HashTotal";

export function SaleHeadCounts(): React.JSX.Element {
  const soldOpenAuctionHeadCount = useSelector(selectSoldOpenAuctionHeadCount);

  const soldOpenAuctionProgenyCount = useSelector(
    selectSoldOpenAuctionProgenyCount,
  );
  const soldLiveWeightHeadCount = useSelector(selectSoldLiveWeightHeadCount);
  const soldLiveWeightProgenyCount = useSelector(
    selectSoldLiveWeightProgenyCount,
  );
  const headCount = useSelector(selectLottedHeadCount);
  const progenyHeadCount = useSelector(selectProgenyHeadCount);

  return (
    <>
      <Grid item xs={6}>
        <h3
          title={`The total quantity of animals sold as ${pricingTypeToString(
            PricingTypeId.PER_KILO,
          )}`}
        >
          Live Weight Hd
        </h3>
        <span>
          {`${formatNumber(soldLiveWeightHeadCount)} ${getProgenyDisplayCount(
            soldLiveWeightProgenyCount,
          )}`}
        </span>
      </Grid>
      <Grid item xs={6}>
        <h3
          title={`The total quantity of animals sold as ${pricingTypeToString(
            PricingTypeId.PER_HEAD,
          )} or ${pricingTypeToString(PricingTypeId.GROSS)}`}
        >
          Open Auction Hd
        </h3>
        <span>
          {`${formatNumber(soldOpenAuctionHeadCount)} ${getProgenyDisplayCount(
            soldOpenAuctionProgenyCount,
          )}`}
        </span>
      </Grid>

      <Grid item xs={6}>
        <h3 title="The total quantity of animals lotted in the sale">
          Lotted Hd
        </h3>
        <span>
          {`${formatNumber(headCount)} ${getProgenyDisplayCount(progenyHeadCount)}`}
        </span>
      </Grid>

      <Grid item xs={6}>
        <SaleProgressHashTotal />
      </Grid>
    </>
  );
}
